import { Box } from '@mantine/core';
import { preberi } from '../pomoc/clanki';
import { ClanekVsebina } from '../pomoc/ClanekVsebina';
import spremembeMd from '../pomoc/spremembe.md?raw';
import { Kartica } from '../postavitev/Podatki';
import { GlavaZaslona, ZaslonSeznama } from '../seznam/Seznam';

const SPREMEMBE = preberi('spremembe', spremembeMd);

/** Zgodovina sprememb: novosti po izdajah iz {@code src/pomoc/spremembe.md} (ob vsaki izdaji dodaj vnos na vrh). */
export function Spremembe() {
  return (
    <ZaslonSeznama>
      <GlavaZaslona naslov={SPREMEMBE.naslov} opis={SPREMEMBE.opis} />
      <Kartica>
        <Box maw={900}>
          <ClanekVsebina clanek={SPREMEMBE} osnova="/pomoc" brezNaslova />
        </Box>
      </Kartica>
    </ZaslonSeznama>
  );
}
